<template>
  <div class="p-l-5 m-b-10">
    <div class="m-b-2 m-t-5">
      <i
        :class="iconMapping[columnName]"
        class="m-t-5 m-r-3 fa"
        tooltip-placement="left"
        aria-hidden="true"
      />
      <strong>{{ columnDisplayName }}</strong>
    </div>

    <table class="table_beauty condensed-alternate routing-plan-args">
      <thead>
        <tr class="bg-transparent">
          <th
            v-t="'BID_AMOUNT'"
            class="text-right routing-plan-args__bid-amount"
          />
          <th
            v-t="'DURATION'"
            class="text-right routing-plan-args__bid-duration"
          />
          <th v-t="'NAME'" />
          <th
            v-if="columnName.toLowerCase() === 'notacceptedringtreetargets'"
            v-t="'REASON'"
          />
        </tr> 
      </thead>
      <tbody>
        <tr
          v-for="(target, index) in parsedCallPlanDetail"
          :key="index"
          class="bg-transparent"
        >
          <td class="text-right">
            <span v-if="target.hasTimedout">-</span>
            <span v-if="!target.hasTimedout">{{ target.bidAmount | currency }}</span>
          </td>

          <td class="text-right">
            <span v-if="target.hasTimedout">-</span>
            <span v-if="!target.hasTimedout">{{ target.duration }}</span>
          </td>

          <td> 
            <a
              rel="noopener"
              target="_blank"
              :href="target.targetPage"
              class="table-ellipsis__name linked-name"
            >
              {{ target.name }}
            </a>
          </td>

          <td v-if="columnName.toLowerCase() === 'notacceptedringtreetargets'">
            {{ target.notAcceptedReason }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

const splitTargetNameRegex = /(\[\d+\.?\d*,\d+,.+\])/gm;
const splitTargetsRegex = /(\[\d+,\s?\d+\],)/gm;

import messages from './locales';
import { currencyFormatter } from '@/modules/reporting/components/AgGridUtils';

export default {
  name: 'PingTreePingingSummary',

  filters: {
    currency(value) {
      return currencyFormatter.format(value);
    }
  },

  props: {
    targets: {
      type: String,
      default: ''
    },
    columnName: {
      type: String,
      default: ''
    },
    columnDisplayName: {
      type: String,
      default: ''
    }
  },
  data() { 
    return {
      parsedCallPlanDetail: [],
      iconMapping: {
        notAcceptedRingTreeTargets: 'fa-close',
        acceptedRingTreeTargets: 'fa-check',
        winningRingTreeTarget: 'fa-trophy'
      }
    };
  },
  watch: {
    targets: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.parsedCallPlanDetail = this.parseCallPlanDetail(this.getTargetsFromString(newValue));
        }
      }
    }
  },
  methods: {
    getTargetsFromString(value) {
      //The string has a list of targets separated by the character \n 
      if (value.indexOf('\n') > -1) {
        return value.split('\n');
      } else {
        const targets = [];

        const splitString = value
          .split(splitTargetsRegex);

        for (let i = 0; i < splitString.length; i += 2) {
          if (splitString[i]) {
            targets.push(`${splitString[i]}${splitString[i + 1] ? splitString[i + 1] : ''}`.replace(/,$/, ''));
          }
        }

        return targets;
      }
    },
    parseCallPlanDetail(targets) {
      if (targets?.length) {
        return targets.map(target => {
          target.replace('\n', '');

          // The target line has the target name along with the pinging data. This splits by a regex so we have the information broken down.
          // [0] - target name, [1] - pinging metadata (bid amount, call duration, rtt id), [2] - ring tree id
          // Here is what a target line would typically look like: "CMHAB - Med O65 - Medication tout[0,0,PIcfcf8418242b419f84d813dd04fcd65b] Ping Timeout (Target Setting: 20 ms)"
          const split = target.split(splitTargetNameRegex);

          //Breaks down the pinging metadata [0] - bid amount [1] - call duration [2] - rtt id
          const metadata = split[1].replace(/[\[\]]/g, '').split(',');
          const notAcceptedReason = split[2] || '';

          //On 1st step time out its we barely have metadata to show, whereas on 2nd step we already have, hence this validation
          const hasTimedout = notAcceptedReason.includes('Ping Timeout') && !notAcceptedReason.includes('Confirmation Step Ping Timeout');

          return {
            name: split[0],
            bidAmount: metadata[0],
            duration: metadata[1],
            targetPage: `#/dashboard/ringtreetarget/edit/${metadata[2]}`,
            notAcceptedReason,
            hasTimedout
          };
        }).sort((targetA, targetB) => {
          const priorityComparison = targetB.bidAmount - targetA.bidAmount;

          if (priorityComparison == 0) {
            return targetB.bidAmount - targetA.bidAmount;
          }

          return priorityComparison;
        });
      }

      return [];
    }
  },
  i18n: {
    locale: 'en',
    messages
  }
};
</script>